import React, { Component } from 'react';

class PagoRapidoKhipuError extends React.Component {



}

export default PagoRapidoKhipuError;